/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import React, { Component } from 'react';
import * as stringParser from '../../../util/string.util'

// let connection = null
let blinkTime = null
export default class WinnerOdds extends Component {
    _ismounted = false
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            book: {},
            market: {},
            lastBook: {},
            mktMsg:''
        };
    }
    componentDidMount() {

        this._ismounted = true

        const socket = this.props.socket;
        if (this.props.market.bettingType === "BOOKMAKER" && this.props.market.provider !== 'BETHUBS') {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return parseFloat(a.id) - parseFloat(b.id);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book && !!this.props.market.metadata.book.runners) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        if (this._ismounted) {
            this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
                if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                    this.props.betForm("", "")
                }
            })
        }
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        if (localStorage.getItem("betExpo") && this._ismounted) {
            this.setState({ expo: JSON.parse(localStorage.getItem("betExpo")) })
        }
        socket.emit('market_room', this.props.market.marketId)
        // if(this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1){
        //     this.props.updateSubscribedMarkets(this.props.market.marketId)
        // }
        let stream = ""
        socket.on("message_room", data => {
            let objData = JSON.parse(data)
            if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
               this.setState({mktMsg:objData.payload.message})
            } 
        });
        socket.on("market_room", data => {

            // let objData = JSON.parse(data)
            // if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
            //     this.setState({ mktMsg: objData.payload.message })
            // } else 
            if (stream !== data && this._ismounted ) {

                stream = data
                let newBook = null
                // if(this.props.consoleRights){
                //     console.log('odds market - ' + this.props.market.marketId)
                //     console.log(new Date().toLocaleString() + ' _ ' + new Date().getMilliseconds());
                //     console.log(data)
                //     console.log('------------------------------------')
                // }
                try {
                    newBook = stringParser.deSrlz(data)
                } catch {
                    let baseData = {
                        marketId: this.props.market.marketId,
                        status: "OPEN",
                        runners: []
                    }
                    Array.prototype.forEach.call(this.state.market.runners,(rnr) => {
                        let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                        baseData.runners.push(data)
                    })
                    newBook = baseData
                }
                if (this.props.market.bettingType === "BOOKMAKER" && this.props.market.provider !== 'BETHUBS') {
                    if (!!newBook.runners) {
                        newBook.runners = newBook.runners.sort(function (a, b) {
                            return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                        });
                    }
                }
                if (this.props.market.marketId === newBook.marketId && this._ismounted) {
                    this.props.updateBook(this.props.market.marketId, newBook)
                    let curBook = this.state.book
                    if (!curBook || !curBook.runners) {
                        this.setState({ book: newBook })
                        return false
                    }
                    Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                        let nrn = newBook.runners[i]
                        if (!nrn) {
                            nrn = {}
                            nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!nrn.back || nrn.back.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        Array.prototype.forEach.call(rn.back,(bk, j) => {
                            if (!!nrn.back[j]) {
                                if (bk.price !== nrn.back[j].price) {
                                    nrn.back[j].has_blink = true
                                }
                                else {
                                    nrn.back[j].has_blink = false
                                }
                            }
                        })
                        if (!nrn.lay || nrn.lay.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!!rn.lay && rn.lay.length > 0) {
                            Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.price !== nrn.lay[k].price) {
                                        nrn.lay[k].has_blink = true
                                    }
                                    else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                        }
                        newBook.runners[i] = nrn
                    });
                    if(!!this.props.isVisible){

                        this.setState({ book: newBook }, () => {
                            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                this.props.betForm("", "")
                            }
                            let self = this
                            blinkTime = setTimeout(function blink() {
                                Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                                    let nrn = newBook.runners[i]
                                    Array.prototype.forEach.call(rn.back,(bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                        if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                self.setState({ book: newBook })
                            }, 500)
                        })
                    }
                    else{
                        // console.log("lastbook", newBook)
                        this.setState({ lastBook: newBook })
                    }
                }
            }
        });
        socket.on('disconnect', () => {
            socket.emit('market_room', this.props.market.marketId)
        })
        this._ismounted = true
    }

    componentWillReceiveProps(){
        if(!!this.props.isVisible && !!this.props.updateProps && Object.keys(this.state.lastBook ).length > 0){

            let newBook = this.state.lastBook
            let curBook = this.state.book

            this.setState({ book: newBook }, () => {
                if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                    this.props.betForm("", "")
                }
                let self = this
                blinkTime = setTimeout(function blink() {
                    Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                        if(!newBook.runners || !newBook.runners[i]){
                            return false
                        }
                        let nrn = newBook.runners[i]
                        Array.prototype.forEach.call(rn.back,(bk, j) => {
                            if (!!nrn.back[j]) {
                                nrn.back[j].has_blink = false
                            }
                        })
                        Array.prototype.forEach.call(rn.lay,(ly, k) => {
                            if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                        })
                        newBook.runners[i] = nrn
                    });
                    self.setState({ book: newBook })
                }, 500)
            })
        }
    }

    componentWillUnmount() {
        this._ismounted = false
        clearTimeout(blinkTime)
        // const socket = this.props.socket;
        // connection.off()
    }

    render() {
        let market = this.props.market
        let book = this.state.book
        market.expo = this.props.mktExpos[this.props.market.marketId]
        market.agentExpo = this.props.mktAgentExpos[this.props.market.marketId]
        let marketExpo = !!this.props.mktExpos[this.props.market.marketId] ? this.props.mktExpos[this.props.market.marketId].runnersExposure : null
        let marketAgentExpo = !!this.props.mktAgentExpos && !!this.props.mktAgentExpos[this.props.market.marketId] ? this.props.mktAgentExpos[this.props.market.marketId].runnersExposure : null
        let multiplayFector = market.marketCondition.volume
        multiplayFector = !!multiplayFector && multiplayFector !== 0 ? multiplayFector : 1;
        const marketrunnercls = !!market.runners && market.runners.length === 2 ? 'col-xl-6' : 'col-xl-4';
        let currencyConversion = JSON.parse(localStorage.getItem('userAccData')).currencyConversion;
        return (
            <>
                {!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && <>
                    <div className="main-analysis mb-2">
                        <div className="top">
                            <div className="toptitle d-inline" style={this.props.betFilter === market.marketId ? { cursor: "pointer", color: "black" } : { cursor: "pointer" }} onClick={() => { this.props.applyFilter() }}>{!!market.marketName ? (this.props.eventType === '7' || this.props.eventType === '4339' ? `${market.marketName} @ ${moment(market.marketTime).format('HH:mm')}` : market.marketName) : market.marketType.replace("_", " ")}</div>
                            <div style={{ "marginTop": "-5px" }}><span onClick={() => { this.props.openUserBooks(this.props.market.marketId) }} className={"bk-btn"}>BOOK</span></div>
                            <div style={{ "marginTop": "-5px" }}><span onClick={() => { this.props.showMarketBetLock(market) }} className={"bk-btn"}>BL <i className="fa fa-lock" aria-hidden="true"></i></span></div>
                            <div style={{ "marginTop": "-5px" }}><span onClick={() => { this.props.openAgentCuttingModal(this.state.market) }} className={"bk-btn"}>BetPlace</span></div>
                            <div className="min-max d-inline ">
                                <span><span className='desktop-minmax'>Min: {(market.marketCondition.minBet / currencyConversion).toFixed(2)} | Max: {(market.marketCondition.maxBet / currencyConversion).toFixed(2)}</span>
                                    <span className={"f-right pl-3"}>{this.props.hideMkt.indexOf(market.marketId) > -1 ? <i className="fa fa-plus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i> : <i className="fa fa-minus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i>}</span>
                                </span>
                            </div>
                            <div style={{ "marginTop": "-5px" }}><span className={"bk-btn"}>{this.props.orderCount}</span></div>
                            {/* <div style={{ "marginTop": "-5px" }}className="ml-2 text-black"> [{this.props.orderCount}] </div> */}
                        </div>
                        <div className="table-responsive analysis-running-market bookmakerbs">
                            {this.props.hideMkt.indexOf(market.marketId) === -1 &&
                                <div className='container-fluid'>
                                    <div className='row'>
                                        <div className='col-12 p-right-left'>
                                            <span>
                                                <span className='mobile-minmax-winnerodds '>Min: {(market.marketCondition.minBet / currencyConversion).toFixed(2)} | Max: {(market.marketCondition.maxBet / currencyConversion).toFixed(2)}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        {!!market.runners && market.runners.map((runner, i) => {
                                            let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners.filter((r) => { return r.selectionId.toString() === runner.id.toString() })[0] : null
                                            runner.name = market.runners[i].name
                                            return (<>   
                                                {!!runner_bk && runner_bk !== {} && <>
                                                    <div className={`col-12 col-sm-6 col-md-6 col-lg-6 ${marketrunnercls} border-top1 p-right-left`}>
                                                        <div className='d-inline-flex w-100 lottery-p-2 odds'>
                                                            <div className='d-inline-block lottery-w75 lottery-inplay v-align-top p-relative'>
                                                                <div className='"d-inline-block'>
                                                                    <span class="in-play-title in-play-title-winnerodds">{runner.name}
                                                                        {(!!marketExpo && !!marketAgentExpo ) ? <span className={(marketExpo[runner.id].sharingMe + marketAgentExpo[runner.id].sharingUp) > 0 ? "match-odds text-success match-odds-winnerodds" : "match-odds text-danger match-odds-winnerodds"}> {Math.round(marketExpo[runner.id].sharingMe + marketAgentExpo[runner.id].sharingUp)}</span>
                                                                        : 
                                                                        !!marketExpo  ? <span className={(marketExpo[runner.id].sharingMe) > 0 ? "match-odds text-success match-odds-winnerodds" : "match-odds text-danger match-odds-winnerodds"}> {Math.round(marketExpo[runner.id].sharingMe)}</span>
                                                                            :
                                                                            !!marketAgentExpo && <span className={(marketAgentExpo[runner.id].sharingUp) > 0 ? "match-odds text-success match-odds-winnerodds" : "match-odds text-danger match-odds-winnerodds"}> {Math.round(marketAgentExpo[runner.id].sharingUp)}</span>}
                                                                    </span>
                                                                    {!!market.expo && market.expo !== {} && !!market.expo.runnersExposure && Object.keys(market.expo.runnersExposure).length >= 4 && <button className="btn btn-sm avgbookbtn  btn-primary  p-absolute winner-right4" onClick={() => { this.props.showAvgBookPopup(market, runner.id) }}>AVG</button>}
                                                                </div>
                                                                
                                                                {/* avg designer  start*/}
                                                                <div className="d-inline-block runnerid float-right p-absolute winner-right4 ">
                                                                    {(!!market.expo && market.expo !== {} && !!market.expo.runnersExposure && Object.keys(market.expo.runnersExposure).length < 4 && !!market.agentExpo && market.agentExpo !== {} && !!market.agentExpo.runnersExposure && Object.keys(market.agentExpo.runnersExposure).length < 4) ? market.runners.map((bk_runn) => {
                                                                            let curr_runn_expo = market.expo.runnersExposure[(runner.id)]
                                                                            let curr_agent_runn_expo = market.agentExpo.runnersExposure[(runner.id)]
                                                                            // Math.round(marketExpo[runner.id].sharingMe + marketAgentExpo[runner.id].sharingUp)
                                                                            let bk_runn_expo = market.expo.runnersExposure[(bk_runn.id)] 
                                                                            let bk_agent_runn_expo = market.agentExpo.runnersExposure[(bk_runn.id)] 
                                                                            //Math.round(marketExpo[bk_runn.id].sharingMe + marketAgentExpo[bk_runn.id].sharingUp)
                                                                            let average = (curr_runn_expo.sharingMe + curr_agent_runn_expo.sharingUp) / Math.abs(bk_runn_expo.sharingMe + bk_agent_runn_expo.sharingUp)
                                                                            return (<>
                                                                                {bk_runn.id !== runner.id &&
                                                                                    <>
                                                                                        <div className="avg-winnerodds ">
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block mr-1 mobtextdotted"> {bk_runn.name}: </span>
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block">{(bk_runn_expo.sharingMe + bk_agent_runn_expo.sharingUp) !== 0 ? <span className={average >= 0 ? "text-success" : "text-danger"}>{parseFloat(Math.abs(average)).toFixed(2)} </span> : null}</span>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </>)
                                                                        })
                                                                        :
                                                                        (!!market.expo && market.expo !== {} && !!market.expo.runnersExposure && Object.keys(market.expo.runnersExposure).length < 4) ? market.runners.map((bk_runn) => {
                                                                            let curr_runn_expo = market.expo.runnersExposure[(runner.id)]
                                                                            // Math.round(marketExpo[runner.id].sharingMe + marketAgentExpo[runner.id].sharingUp)
                                                                            let bk_runn_expo = market.expo.runnersExposure[(bk_runn.id)] 
                                                                            //Math.round(marketExpo[bk_runn.id].sharingMe + marketAgentExpo[bk_runn.id].sharingUp)
                                                                            let average = (curr_runn_expo.sharingMe) / Math.abs(bk_runn_expo.sharingMe)
                                                                            return (<>
                                                                                {bk_runn.id !== runner.id &&
                                                                                    <>
                                                                                        <div className="avg-winnerodds">
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block mr-1 mobtextdotted"> {bk_runn.name}: </span>
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block">{bk_runn_expo.sharingMe !== 0 ? <span className={average >= 0 ? "text-success" : "text-danger"}>{parseFloat(Math.abs(average)).toFixed(2)} </span> : null}</span>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </>)
                                                                        })
                                                                        :
                                                                        (!!market.agentExpo && market.agentExpo !== {} && !!market.agentExpo.runnersExposure && Object.keys(market.agentExpo.runnersExposure).length < 4) && market.runners.map((bk_runn) => {
                                                                            let curr_agent_runn_expo = market.agentExpo.runnersExposure[(runner.id)]
                                                                            // Math.round(marketExpo[runner.id].sharingMe + marketAgentExpo[runner.id].sharingUp)
                                                                            let bk_agent_runn_expo = market.agentExpo.runnersExposure[(bk_runn.id)] 
                                                                            //Math.round(marketExpo[bk_runn.id].sharingMe + marketAgentExpo[bk_runn.id].sharingUp)
                                                                            let average = (curr_agent_runn_expo.sharingUp) / Math.abs(bk_agent_runn_expo.sharingUp)
                                                                            return (<>
                                                                                {bk_runn.id !== runner.id &&
                                                                                    <>
                                                                                        <div className="avg-winnerodds">
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block mr-1 mobtextdotted"> {bk_runn.name}: </span>
                                                                                            <span className="font-12 px-0 py-0 text-dark d-inline-block">{bk_agent_runn_expo.sharingUp !== 0 ? <span className={average >= 0 ? "text-success" : "text-danger"}>{parseFloat(Math.abs(average)).toFixed(2)} </span> : null}</span>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </>)
                                                                        })

                                                                    }
                                                                    {/* {!!market.expo && market.expo !== {} && !!market.expo.runnersExposure && Object.keys(market.expo.runnersExposure).length >= 4 && <button className="btn btn-sm avgbookbtn  btn-primary " onClick={() => { this.props.showAvgBookPopup(market, runner.id) }}>AVG</button>} */}
                                                                </div>
                                                                {/* avg designer  end*/}
                                                            </div>
                                                            {!!runner_bk.back && 
                                                            <div className='d-inline-block lottery-w25 lottery-inplay btn-back ' style={!!runner_bk.back[0] && runner_bk.back[0].has_blink ? { background: "gold" } : null}>
                                                                <div className={book.status === "OPEN" && runner_bk.status === "ACTIVE" ? book.sportingEvent === true ? "ballrunning-winnerodds" : "" : "suspended-winnerodds"}>
                                                                    <a className="btn-back border-bottom1 w-100 text-center d-block font-weight-bold " side="Back"><div>{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 ? (runner_bk.back[0].price.indexOf('.') > -1 ? runner_bk.back[0].price.substring(0,(runner_bk.back[0].price.indexOf('.') + 3)) : runner_bk.back[0].price) : ""}</div></a>
                                                                </div>
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </>} 
                                        </>)})}
                                    </div>
                                    {!!this.props.msgMarket && this.state.mktMsg === '' &&
                                        <tr className="">
                                            <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.props.msgMarket}</span></td>
                                        </tr>
                                    }
                                    {this.state.mktMsg !== '' &&
                                        <tr className="">
                                            <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.state.mktMsg}</span></td>
                                        </tr>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </>}
            </>
        )
    }
}
